import axios from 'axios'
import { blobToDataURL } from './blob-to-dataurl'

export async function fetchPngToDataUri (url) {
  try {
    let response = await axios.get(url, { responseType: 'arraybuffer'})
    let dataUri = await blobToDataURL(new Blob([response.data], { type: 'image/png' }))
    return await dataUri
  } catch (err) {
    throw err
  }
}